<template>
    <vehicle_updating_today-component>
        <b-row>
            <b-col md="12" class="mt-3">
                <div>
                    <b-row>
                        <b-col md="4">
                           <b-form-group label="Selected Date:"  :label-cols="5" >

                                <v-date-picker mode='single' input-class="dateInput" :available-dates='{ start: null, end: new Date() }' v-model='dateSearch'>
                                </v-date-picker>

                            </b-form-group>
                        </b-col>
                        
                        <b-col md="4">
                            <b-form-group >
                                <b-form-textarea v-model="vehicleSearch" style="height: 40px;" placeholder="Search by Vehicle No : MH12AB1234 "></b-form-textarea>      
                            </b-form-group>
                        </b-col>

                        <b-col md="4">
                            <b-form-group >
                                <b-form-textarea v-model="ebnSearch" style="height: 40px;" placeholder="Search by EBN No : EBN1023 "></b-form-textarea>      
                            </b-form-group>
                        </b-col>
                            
                        <b-col md="6" class="text-right">
                            <b-button :disabled="!dateSearch && !vehicleSearch && !ebnSearch" @click="searchVehicleUpdation_filters()"  size="md" variant="primary">Search</b-button>
                            &nbsp;
                            <b-button :disabled="!dateSearch && !vehicleSearch && !ebnSearch" @click="clearVehicleUpdation_filters()"    size="md" variant="danger">Clear</b-button>
                        </b-col>   
                        
                        <b-col md="6">
                            <div class="text-right">
                                <b-button   @click="downloadENB_expiring()" size="md" variant="primary">Download</b-button>
                            </div>
                        </b-col>
                   
                    </b-row> 
                </div>



                <div class="text-right">
                    <b>Total Records : <strong style="color: red;">{{totalRows}}</strong></b>
                </div>
                

                <b-table responsive show-empty :busy="isBusy" :items="VehicleUpdationToday" :fields="fields"  :bordered="bordered"    :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"  @filtered="onFiltered" :tbody-tr-class="rowClass"> 

                    <div slot="table-busy" class="text-center text-danger my-2">
                      <b-spinner class="align-middle">
                      </b-spinner>
                      <strong>Loading...</strong>
                    </div> 
                    <!-- <template slot="select" slot-scope="row">
                        <input type="checkbox" @change="multiselectdesign($event)" v-bind:value="row.item.parentawb"  class="designcheckbox"  v-model="CheckLoadID" >
                    </template> -->
                </b-table>
                
                <paginate
                    :page-count="noofpages"
                    :page-range="10"
                    :margin-pages="2"
                    :click-handler="clickCallback"
                    :prev-text="'Prev'"
                    :next-text="'Next'"
                    :container-class="'pagination'"
                    :page-class="'page-item'">
                </paginate>

                
            </b-col>
        </b-row>
    </vehicle_updating_today-component>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import Vue from 'vue'
export default {
    data() {
        return {
            isBusy: false, 
            
            fields :[],
            VehicleUpdationToday :[],
            isBusy : false,
            noofpages:'',
            pageNum:1,

            dateSearch:"",
            vehicleSearch:"",
            ebnSearch:"",
            allRecords: [],
            perPage: 50,

            totalRows :0,
            CheckLoadID :[],
            SelectLoadID :[],
            selectDateFrom: '',
            route_id : null,
            accessBody:[],
            isReadOnly:false,
        }
    },

    created() {
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        this.User_type = userInfo.user_type;

        this.route_id = this.$route.params.id;


        this.accessBody = userInfo.body;
        this.ischeckbodyvalidation();

        this.VehicleUpdationRecords(this.pageNum);

    },
    methods: {
        ischeckbodyvalidation(){
        for (let i = 0; i < this.accessBody.length; i++) {
            const element = this.accessBody[i];
        
            if (element.title=='Part B - Vehicle Updation' && element.isReadonly==true && this.route_id=='normal') {
            this.isReadOnly=true
            }
        if (element.child) {
            for (let j = 0; j < element.child.length; j++) {
            const k = element.child[j];
            if (k.title=='Part B - Vehicle Updation' && k.isReadonly==true && this.route_id=='normal') {
                this.isReadOnly=true
            }
            if (k.title=='Part B - Vehicle Updation' && k.isReadonly==true && this.route_id=='asn') {
                this.isReadOnly=true
            }
            
            }
        }
        }
        console.log(" this.isReadOnly", this.isReadOnly)
        },
        clickCallback(pageNum){
            this.pageNum = pageNum;
            this.paginateData(pageNum);
        },

        VehicleUpdationRecords : function(pageNo){
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

            this.isBusy=true;
            if (this.route_id=='normal') {
                this.fields=[
                    { key: 'invoiceno', label: 'Load Id', sortable: true, sortDirection: 'desc' },
                    // { key: 'parentawb', label : 'Parent AWB', sortable: true},
                    { key: 'ebn', label : 'EBN No', sortable: true},
                    { key: 'vehicle_no', label : 'Vehicle No', sortable: true},
                    { key: 'createddate', label : 'Create Date', sortable: true},                    
                ]
            }
            
            if (this.route_id=='asn') {
                this.fields=[
                    { key: 'invoiceno', label: 'Load Id', sortable: true, sortDirection: 'desc' },
                    // { key: 'parentawb', label : 'Parent AWB', sortable: true},
                    { key: 'ebn', label : 'EBN No', sortable: true},
                    { key: 'vehicle_no', label : 'Vehicle No', sortable: true},
                    { key: 'createddate', label : 'Create Date', sortable: true}, 
                ]
            }
            
            const obj={
                page_no:`${pageNo}`,
                is_asn: this.route_id=='normal' ? 'NO': 'YES',
                pushflag: '0', 
                date: this.dateSearch ? this.dateSearch.toLocaleDateString('en-CA') : new Date().toISOString().slice(0, 10),
                vehicleNo: this.vehicleSearch || '',
                ebnNo: this.ebnSearch || ''
            }
            console.log("obj",obj)
            this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/vehicleUpdation`,obj)
            .then(result => {

                this.isBusy=false;
                if (result.body.returnmsg === "Successful") {

                                  
                    this.allRecords = result.body.returnvalue.map(item => ({
                        ...item,
                        createddate: item.createddate
                            ? item.createddate.split('T')[0]
                            : ''
                    }));

                    this.totalRows = this.allRecords.length;

                    this.noofpages = Math.ceil(this.totalRows / 50);

                    this.paginateData(pageNo);

                }else{

                    this.VehicleUpdationToday=[];
                    this.totalRows=0;

                }
            }).catch(ex => {
                console.log("error", ex);
            });
        },

        searchVehicleUpdation_filters(){
            this.VehicleUpdationRecords(this.pageNum);
        },

        clearVehicleUpdation_filters(){
            this.pageNum=1;
            this.VehicleUpdationToday = [];
            this.totalRows = 0;
            this.dateSearch = "";
            this.vehicleSearch = "";
            this.ebnSearch = "";
            this.VehicleUpdationRecords(this.pageNum);

        },

        paginateData(pageNo) {
            const start = (pageNo - 1) * this.perPage;
            const end = start + this.perPage;

            this.VehicleUpdationToday =
                this.allRecords.slice(start, end);
        },

        downloadENB_expiring(){
            // alert("i")
            document.getElementById("overlay").style.display = "block";
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            const obj={
                sysusermasterid:`${userInfo.sysusermasterid}`,
                recordtype:this.searchvaluesarr.length>0?"search":"expired",
                searchpayld:this.searchvaluesarr.length>0?this.searchvaluesarr:[],
                is_asn: (this.route_id=='normal' || this.route_id =='rbftlshipment')  ? 'NO': 'YES',
                routeid: this.route_id
            }
            console.log("obj",obj)
            // return false;
            this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/getEBNExpiryRecordsofCurrentDateCSVDownload`,obj)
            .then(result => {
                console.log("result",result)
                document.getElementById("overlay").style.display = "none";
                    if(result.body=="success")
                    {
                    this.$fire({
                             text:"Please Check Your Mail For Downlod Link",
                             type: "success",
                             timer: 30000
                           });
                }
                else
                {
                    // alert("Can not Download");
                    this.$fire({
                             text:"Can not Download",
                             type: "error",
                             timer: 30000
                           });
                }
            }).catch(ex => {
                console.log("error", ex);
            });
        },

        multiselectdesign(e){
        this.SelectLoadID=[];
        console.log("this.SelectLoadID",this.SelectLoadID)
        // this.CheckLoadID=[];
        var userdata = localStorage.getItem('userData')
            var userInfo = JSON.parse(userdata)
            console.log("this.CheckLoadID",this.CheckLoadID)
                if (this.CheckLoadID.length >0)

                {
                // alert("in");
                console.log("CheckLoadID",this.CheckLoadID);
                this.SelectLoadID=this.CheckLoadID;
                    document.getElementById("DatePickerdiaplay").style.display ="block";
                    // }
                }
                
                else{
                document.getElementById("DatePickerdiaplay").style.display ="none";
                }

        },

        manuallyUpdateRecord :function () {
            var userdata = localStorage.getItem('userData')
            var userInfo = JSON.parse(userdata)
            
            var today = this.selectDateFrom;
            // Current Date
            var date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();

            console.log("date",date)
            const obj={
                allparrentawbArr:this.CheckLoadID,
                ebnexpdate:`${date}`,
            }
            console.log("obj",obj)
            // return false;
            this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/manuallyUpdateEBNExpiryRecords`,obj)
            .then(result => {
                console.log("result",result)
                if (result.body.returnmsg === "Successful") {
                    this.$fire({
                        text:result.body.returnvalue,
                        type: "success",
                        timer: 30000
                    }); 
                    this.pageNum=1;
                    this.EBNExpiryRecords(this.pageNum);
                    document.getElementById("DatePickerdiaplay").style.display = "none"; 
                    this.CheckLoadID=[];
                    this.selectDateFrom =[];
                } else {
                        this.$fire({
                        text:result.body.returnvalue,
                        type: "error",
                        timer: 30000
                    }); 
                }
            }).catch(ex => {
                console.log("error", ex);
            });
        },
        rowClass(item, type) {
            if(item){
            if (item.error!=null) { 
                return 'table-danger'
            }
            }
        },

    },
    computed: {
      rows() {
        return this.VehicleUpdationToday.length
      }
    },
}
</script>